'use strict';

exports.__esModule = true;
exports.calculateSizeFit = calculateSizeFit;
function calculateSizeFit() {
  throw Error('There is no implementation for calculating image fit size. You are welcome to use your own and/or add it to this library');
}